var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_268_974)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2098 12.71C18.1169 12.6163 18.0063 12.5419 17.8844 12.4911C17.7625 12.4403 17.6318 12.4142 17.4998 12.4142C17.3678 12.4142 17.2371 12.4403 17.1152 12.4911C16.9934 12.5419 16.8828 12.6163 16.7898 12.71L13.4998 16V6C13.4998 5.73478 13.3945 5.48043 13.2069 5.29289C13.0194 5.10536 12.765 5 12.4998 5C12.2346 5 11.9802 5.10536 11.7927 5.29289C11.6052 5.48043 11.4998 5.73478 11.4998 6V16L8.20982 12.71C8.11685 12.6163 8.00625 12.5419 7.88439 12.4911C7.76253 12.4403 7.63183 12.4142 7.49982 12.4142C7.3678 12.4142 7.2371 12.4403 7.11524 12.4911C6.99338 12.5419 6.88278 12.6163 6.78982 12.71C6.60356 12.8974 6.49902 13.1508 6.49902 13.415C6.49902 13.6792 6.60356 13.9326 6.78982 14.12L11.0898 18.41C11.4632 18.7856 11.9702 18.9978 12.4998 19C13.0259 18.9951 13.5289 18.7832 13.8998 18.41L18.1998 14.12C18.3874 13.934 18.4937 13.6813 18.4956 13.4171C18.4975 13.1529 18.3947 12.8987 18.2098 12.71Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_974",
    x1: 24.5,
    y1: -0.00000123061,
    x2: -4.06243,
    y2: 8.30056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.f9bfaad7e2136209b6da83b73cb12d75.svg";
export { ForwardRef as ReactComponent };